import type { PdfCanvasColorGroup } from "./pdfCanvasTypes";

/** PDF sayfa görüntüsünün varsayılan ve “sıfırla” zoom hedefi genişliği (px). */
export const PDF_CANVAS_MAX_WIDTH = 950;
/** Konteyner bu genişliğin altındayken üst üste (stacked), üstündeyken yan panel + PDF (wide) düzeni kullanılır. */
export const PDF_CANVAS_WIDE_LAYOUT_MIN_WIDTH = 1444;
/** Wide düzende sol araç çubuğu / legend / önizleme sütununun sabit genişliği (px). */
export const PDF_CANVAS_WIDE_SIDEBAR_WIDTH = 250;
/** Wide düzende sayfa küçük önizleme kutusunun genişliği (px); stacked modda varsayılan önizleme boyutu kullanılır. */
export const PDF_CANVAS_WIDE_PREVIEW_BOX_WIDTH = 100;
/** Readonly modda sayfa üzerindeki “dinle” marker’ının, not koordinatından yukarı kaydırılması (px). */
export const PDF_CANVAS_READONLY_NOT_MARKER_OFFSET_Y_PX = 20;

export const PDF_ANNOTATION_COLOR_GROUPS: PdfCanvasColorGroup[] = [
    {
        groupName: "Nota",
        items: [
            { color: "rgba(255, 235, 59, 1)", label: "Net olmama" },
            { color: "rgba(255, 152, 0, 1)", label: "Yarım ses, 1 ses hata" },
            { color: "rgba(244, 67, 54, 1)", label: "Yanlış melodi seviyesinde hata" },
        ],
    },
    {
        groupName: "Ritim",
        items: [
            { color: "rgba(33, 150, 243, 1)", label: "Tartım hatası" },
            { color: "rgba(76, 175, 80, 1)", label: "Ritmin önünde/gerisinde gitme" },
        ],
    },
    {
        groupName: "Diğer",
        items: [
            { color: "rgba(156, 39, 176, 1)", label: "Diğer" },
        ],
    },
];

export function getPdfAnnotationLegendItems() {
    return PDF_ANNOTATION_COLOR_GROUPS.flatMap(g => g.items);
}
